var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 124,
    viewBox: "0 0 126 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_12_11126)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 45.5,
    rx: 36,
    ry: 37.5,
    fill: "url(#paint0_linear_12_11126)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_12_11126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 -24L51.2611 33.8293L83 -14.6218L56.9095 37.0905L108.622 11L60.1707 42.7389L118 46L60.1707 49.2611L108.622 81L56.9095 54.9095L83 106.622L51.2611 58.1707L48 116L44.7389 58.1707L13 106.622L39.0905 54.9095L-12.6218 81L35.8293 49.2611L-22 46L35.8293 42.7389L-12.6218 11L39.0905 37.0905L13 -14.6218L44.7389 33.8293L48 -24Z",
    fill: "url(#paint1_radial_12_11126)",
    fillOpacity: 0.72
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_12_11126",
    x: -27.1,
    y: -16.1,
    width: 120.2,
    height: 123.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.05,
    result: "effect1_foregroundBlur_12_11126"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12_11126",
    x: -29.9,
    y: -31.9,
    width: 155.8,
    height: 155.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.95,
    result: "effect1_foregroundBlur_12_11126"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_11126",
    x1: 69,
    y1: 45.5,
    x2: -3,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#260475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41E4F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12_11126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48 49.5) rotate(90) scale(66.5 63.3351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyStar);
export default __webpack_public_path__ + "static/media/energy-star.5c3d8d3e22131aa2c446d6a283caf80e.svg";
export { ForwardRef as ReactComponent };